export default __webpack_public_path__ + "static/media/ElasticCache.82f6329f.svg";